"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
/**
 *
 * @category component
 */
const IconButtonCell = ({ columnId, Icon, IconButtonProps, tooltip, ...cellProps }) => {
    return (react_1.default.createElement(TableCell_1.default, { ...cellProps },
        react_1.default.createElement(Tooltip_1.default, { ...tooltip },
            react_1.default.createElement(IconButton_1.default, { ...IconButtonProps },
                react_1.default.createElement(Icon, null)))));
};
exports.default = IconButtonCell;
